import React, { useEffect, useState } from 'react';
import { NavigationDropdownMode, } from '../../Navigation.types';
import NavigationPromo from '../NavigationPromo/NavigationPromo';
import S from './NavigationDropdown.styles';
import YourSolutionNavigation from '../YourSolutionNavigation/YourSolutionNavigation';
const NavigationItem = ({ isActive = false, tabIndex = 0, title, url, style, onActive, onInactive, }) => {
    return (React.createElement(S.Item, { onMouseEnter: () => {
            onActive && onActive();
        } },
        React.createElement(S.Link, { href: url, isActive: isActive, tabIndex: tabIndex, isBold: style === 'bold', onKeyDown: (event) => {
                if (event.key.toLowerCase() === 'arrowright') {
                    event.preventDefault();
                    onActive && onActive();
                }
                if (event.key.toLowerCase() === 'arrowleft') {
                    event.preventDefault();
                    onInactive && onInactive();
                }
                if (event.key.toLowerCase() === 'escape') {
                    event.preventDefault();
                    onInactive && onInactive();
                }
            } }, title)));
};
const NavigationDropdown = ({ isActive, items = [], mode, promo: defaultPromo, yourSolutionNavigationProps, onYsButtonClick, onYspButtonClick, }) => {
    const [activeLevel1Id, setActiveLevel1Id] = useState('');
    const [activeLevel2Id, setActiveLevel2Id] = useState('');
    const [activeLevel3Id, setActiveLevel3Id] = useState('');
    // Get the active item for each level.
    const level1Item = items.find((item) => item.id === activeLevel1Id);
    const level2Item = level1Item?.children?.find((item) => item.id === activeLevel2Id);
    const level3Item = level2Item?.children?.find((item) => item.id === activeLevel3Id);
    // Get the promo from the lowest level active item.
    const activePromo = level3Item?.promo ?? level2Item?.promo ?? level1Item?.promo ?? defaultPromo;
    const isActiveLevelYourSolution = items.find((x) => x.id === activeLevel1Id)?.dropdown === NavigationDropdownMode.YourSolution;
    const activeItemYourSolutionProps = items.find((x) => x.id === activeLevel1Id)?.yourSolutionNavigationProps;
    // Reset active selection when dropdown is hidden.
    useEffect(() => {
        if (!isActive) {
            setActiveLevel1Id('');
            setActiveLevel2Id('');
        }
    }, [isActive]);
    return (React.createElement(S.Container, { isActive: isActive, mode: mode, onKeyDown: (event) => {
            if (event.key.toLowerCase() === 'escape') {
                if (activeLevel2Id) {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveLevel2Id('');
                    return;
                }
                if (activeLevel1Id) {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveLevel1Id('');
                    return;
                }
            }
        } },
        React.createElement(S.Inner, null, mode === NavigationDropdownMode.YourSolution ? (React.createElement(React.Fragment, null, yourSolutionNavigationProps && (React.createElement(YourSolutionNavigation, { ...yourSolutionNavigationProps })))) : (React.createElement(React.Fragment, null,
            renderColumn1(),
            renderColumn2(),
            renderColumn3(),
            renderColumn4(),
            isActiveLevelYourSolution && activeItemYourSolutionProps && (React.createElement(S.YourSolutionColumn, null,
                React.createElement(YourSolutionNavigation, { ...activeItemYourSolutionProps, onYsButtonClick: onYsButtonClick, onYspButtonClick: onYspButtonClick }))))))));
    function renderColumn1() {
        return (React.createElement(S.Column1, null,
            React.createElement(S.List, null, items.map((item) => (React.createElement(NavigationItem, { key: item.id, ...item, isActive: activeLevel1Id === item.id, tabIndex: isActive && (!activeLevel1Id || activeLevel1Id === item.id) ? 0 : -1, onActive: () => {
                    setActiveLevel1Id(item.id);
                    setActiveLevel2Id('');
                }, onInactive: () => {
                    setActiveLevel1Id('');
                    setActiveLevel2Id('');
                } }))))));
    }
    // Perf: render only the active level-1 branch's children instead of emitting a
    // hidden Column2 for every top-level item. The deep tree is the bulk of the
    // header's DOM weight; it now mounts on hover. Crawlability of the deep links
    // is covered by the server-rendered SEO <nav> in Header.ascx.
    function renderColumn2() {
        const activeItem = items.find((item) => item.id === activeLevel1Id);
        if (!activeItem?.children || activeItem.children.length < 1) {
            return null;
        }
        return (React.createElement(S.Column2, { key: activeItem.id, isActive: true },
            React.createElement(S.List, null, activeItem.children.map((child) => (React.createElement(NavigationItem, { key: child.id, ...child, isActive: activeLevel2Id === child.id, tabIndex: !activeLevel2Id || activeLevel2Id === child.id ? 0 : -1, onActive: () => {
                    setActiveLevel2Id(child.id);
                    setActiveLevel3Id('');
                }, onInactive: () => {
                    setActiveLevel2Id('');
                    setActiveLevel3Id('');
                } }))))));
    }
    function renderColumn3() {
        if (mode === NavigationDropdownMode.TwoLevels && activePromo && !isActiveLevelYourSolution) {
            return (React.createElement(S.Column3, { isActive: true },
                React.createElement(NavigationPromo, { ...activePromo })));
        }
        // Only the active level-2 branch's children are rendered (mounted on hover).
        const activeItem = items.find((item) => item.id === activeLevel1Id);
        const activeChild = activeItem?.children?.find((child) => child.id === activeLevel2Id);
        if (!activeChild?.children) {
            return null;
        }
        return (React.createElement(S.Column3, { key: activeChild.id, isActive: true },
            React.createElement(S.List, null, activeChild.children.map((childChild) => (React.createElement(NavigationItem, { key: childChild.id, ...childChild, tabIndex: 0, onActive: () => {
                    setActiveLevel3Id(childChild.id);
                }, onInactive: () => {
                    setActiveLevel3Id('');
                } }))))));
    }
    function renderColumn4() {
        if (mode !== NavigationDropdownMode.ThreeLevelsPromo ||
            !activePromo ||
            isActiveLevelYourSolution) {
            return null;
        }
        return (React.createElement(S.Column4, { isActive: true },
            React.createElement(NavigationPromo, { ...activePromo })));
    }
};
export default NavigationDropdown;
